import { c as _c } from "react/compiler-runtime";
// Note: this is a temporary hook that is being used to standardize the process
// of setting user data in Apollo Client. This will be replaced within the next
// 2 weeks, once we update all instances to use Jotai-based state instead.

import useSetUser from 'global-state/user/useSetUser';
import { useCallback } from 'react';
const useResetUserData = () => {
  const $ = _c(2);
  const setUser = useSetUser();
  let t0;
  if ($[0] !== setUser) {
    t0 = () => {
      setUser(null);
    };
    $[0] = setUser;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const resetUserData = t0;
  return resetUserData;
};
export default useResetUserData;